import { toQuery, type HttpClient } from '../client';
import type { OpsPerfQuery, OpsPerfRow } from '../types/opsPerf';

const BASE = '/ops/perf';

/** 运营人效排行（只读聚合表）。 */
export function createOpsPerfApi(http: HttpClient) {
  return {
    rank(query?: OpsPerfQuery): Promise<OpsPerfRow[]> {
      return http.request<OpsPerfRow[]>({ path: `${BASE}/rank`, query: toQuery(query ?? {}) });
    }
  };
}

export type OpsPerfApi = ReturnType<typeof createOpsPerfApi>;
